var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 165,
    viewBox: "0 0 159 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 160C123.407 160 159 124.183 159 80C159 35.8172 123.407 0 79.5 0C35.5934 0 0 35.8172 0 80C0 124.183 35.5934 160 79.5 160Z",
    fill: "#3897F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9404 49.4864C67.9404 49.4864 60.5184 44.5384 52.1502 44.7487C43.782 44.959 40.64 53.5499 40.1947 56.03C39.7494 58.5102 40.4235 59.8647 35.4632 59.8647C30.5029 59.8647 20.1184 58.9617 16.061 64.3797C12.0037 69.7977 11.546 75.8837 15.158 79.7184C18.77 83.5531 20.106 85.1302 20.106 85.1302C20.106 85.1302 16.2713 88.7422 18.0773 93.7026C19.8833 98.6629 26.427 100.92 30.7132 100.92C34.9993 100.92 41.5368 94.8282 43.3428 91.2224C45.1488 87.6166 50.338 88.7484 54.3953 83.1016C58.4527 77.4547 56.4302 70.4657 55.7498 66.6311C55.0695 62.7964 55.9787 54.8796 61.3905 52.8757C66.8023 50.8718 67.7053 50.8409 67.7053 50.8409L67.9404 49.4864Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 159.35L21.2417 130.25C21.7773 125.265 22.8345 120.35 24.396 115.586C27.105 107.013 30.2655 93.2518 34.1002 88.5141C37.9348 83.7764 50.7995 79.4902 50.7995 79.4902C50.7995 79.4902 63.2065 84.9083 66.5897 87.3884C69.9729 89.8686 75.6135 94.1547 77.4134 97.9894C79.2132 101.824 80.8027 111.071 83.7344 114.454C86.6661 117.837 93.2097 124.609 92.9809 130.924C92.752 137.239 91.6264 139.719 91.6264 141.303C91.6264 142.886 88.4721 140.969 82.6087 141.643C76.7454 142.317 72.5706 144.247 72.0943 144.921C71.6181 145.595 60.2687 163.865 60.2687 163.865",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 159.35L21.2417 130.25C21.7773 125.265 22.8345 120.35 24.396 115.586C27.105 107.013 30.2655 93.2518 34.1002 88.5141C37.9348 83.7764 50.7995 79.4902 50.7995 79.4902C50.7995 79.4902 63.2065 84.9083 66.5897 87.3884C69.9729 89.8686 75.6135 94.1547 77.4134 97.9894C79.2132 101.824 80.8027 111.071 83.7344 114.454C86.6661 117.837 93.2097 124.609 92.9809 130.924C92.752 137.239 91.6264 139.719 91.6264 141.303C91.6264 142.886 88.4721 140.969 82.6087 141.643C76.7454 142.317 72.5706 144.247 72.0943 144.921C71.6181 145.595 60.2687 163.865 60.2687 163.865",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8614 108.139C77.8614 108.139 80.1189 120.775 80.5704 123.929C81.0219 127.083 74.707 139.948 73.1484 141.302",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6793 108.139C72.6793 108.139 72.2278 118.74 72.9019 123.929C73.5761 129.118 74.9306 135.68 73.8049 137.69",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8906 127.312C79.8906 127.312 83.7253 124.157 88.6856 125.512",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9219 124.609C81.9219 124.609 84.8535 122.803 87.5625 122.803",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1214 90.5428L75.1563 94.6063L77.6303 106.11L74.0183 99.7955L72.2184 107.465L69.9609 93.4806C69.9609 93.4806 70.8701 88.743 73.1214 90.5428Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1042 69.792C64.1042 69.792 61.3952 72.266 59.3666 73.1752C57.3379 74.0844 54.8516 74.9812 54.8516 74.9812L67.2586 99.7952L72.2065 107.465C72.2065 107.465 71.9777 100.921 71.9777 98.6633C71.9488 97.0749 71.7979 95.491 71.5262 93.9257L77.3895 86.7078C77.3895 86.7078 79.1955 70.0085 77.6184 67.3119C76.0412 64.6152 67.0359 66.8603 64.1042 69.792Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9623 80.4245L73.6329 76.5527C73.6329 76.5527 72.6556 77.4805 71.9629 83.4922C71.7333 86.2088 72.3167 88.9322 73.6391 91.3162L77.35 86.7084C77.35 86.7084 77.7088 83.9128 77.9623 80.4245Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105.373 62.6109C105.373 62.6109 103.771 70.3791 102.404 72.8902C101.037 75.4013 99.1077 76.7806 98.9469 77.8939C98.4831 81.7471 98.4954 83.3737 97.3512 84.9756C96.207 86.5775 89.8118 90.4617 85.9276 91.3709C82.0435 92.2801 79.7427 92.9728 78.6108 91.8285C77.479 90.6843 73.3598 84.7468 73.3598 82.2357C73.3598 79.7246 72.6733 79.0381 73.3598 77.4362C74.0463 75.8343 74.0463 71.7213 74.0463 71.7213C74.0463 71.7213 74.0463 69.6679 76.7863 66.2414C79.5262 62.815 84.7834 61.912 88.6676 61.912C92.5517 61.912 92.997 59.1658 97.1224 58.0278C101.248 56.8898 104.229 60.3224 105.373 62.6109Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3913 76.3225C95.915 77.1203 95.2162 77.5904 94.8389 77.3677C94.4616 77.1451 94.542 76.3039 95.0244 75.5122C95.5068 74.7206 96.1996 74.2443 96.5768 74.467C96.9541 74.6896 96.8737 75.5184 96.3913 76.3225Z",
    fill: "#263238"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3047 71.926C95.3047 71.926 98.1931 70.7323 99.6898 73.4227",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3795 85.0015C97.9552 84.0054 98.3391 82.9103 98.5114 81.7729C96.7363 80.8019 92.8274 78.5134 90.7493 76.0889C88.0093 72.8913 82.5295 65.123 82.5295 65.123L81.6327 66.2673L86.2033 73.8067C86.2033 73.8067 80.9461 78.1362 77.2908 78.1362C74.4458 78.1362 73.8149 77.0353 73.6788 76.5405C73.6133 76.8505 73.5223 77.1546 73.4067 77.4496C72.7202 79.0515 73.4067 79.7319 73.4067 82.2492C73.4067 84.7664 77.5197 90.704 78.6577 91.842C79.7957 92.98 82.0904 92.2997 85.9745 91.3843C89.8587 90.469 96.2353 86.6034 97.3795 85.0015Z",
    fill: "#3897F0",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6941 68.0912C82.6943 66.9122 85.0006 66.3566 87.3182 66.4955C91.2024 66.7243 95.773 68.32 96.9173 66.2666C98.0615 64.2132 98.2903 60.3229 101.717 61.2382C105.143 62.1536 105.601 64.207 105.601 64.207C105.601 64.207 112.683 63.9782 113.369 60.094C114.056 56.2099 110.172 50.0435 107.654 49.5796C105.137 49.1157 102.855 48.6642 102.855 48.6642C102.855 48.6642 94.1959 39.7517 83.8918 40.0053C73.5876 40.2589 69.0479 44.3348 66.5306 53.0308C64.0133 61.7268 65.1575 64.9121 63.098 67.8747C61.0384 70.8373 59.9003 73.8184 64.9534 73.3607C70.0065 72.9031 73.4083 69.7054 75.9194 68.5612C77.415 67.8802 79.0944 67.7149 80.6941 68.0912Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3837 69.6924C81.3837 69.6924 84.1237 66.2659 81.6126 62.6106C79.1015 58.9553 71.7847 66.037 72.9536 69.9212C74.1226 73.8053 77.0666 73.3477 77.0666 73.3477",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3837 69.6924C81.3837 69.6924 84.1237 66.2659 81.6126 62.6106C79.1015 58.9553 71.7847 66.037 72.9536 69.9212C74.1226 73.8053 77.0666 73.3477 77.0666 73.3477",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6537 72.0488L70.4152 100.017L65.6776 107.687L48.9844 78.8152L56.6537 72.0488Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3538 142.403C73.3538 142.403 73.0384 137.003 79.9222 136.465C86.8061 135.927 92.1437 138.89 92.4344 143.454C92.725 148.019 78.6667 145.075 77.1019 145.075C75.5371 145.075 73.3538 142.403 73.3538 142.403Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M150.274 156.906H58.6875V162.052H150.052",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M150.274 156.906H58.6875V162.052H150.052",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M117.786 102.053L93.875 111.973V148.972H102.899V114.231L119.592 104.984L117.786 102.053Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M130.255 137.269C130.093 137.194 129.956 137.074 129.86 136.924C129.764 136.774 129.713 136.6 129.713 136.422C129.713 136.243 129.764 136.069 129.86 135.919C129.956 135.769 130.093 135.649 130.255 135.574C130.255 135.328 130.157 135.092 129.983 134.918C129.809 134.744 129.573 134.646 129.327 134.646H121.373C121.391 135.604 121.061 136.535 120.445 137.269C120.446 137.447 120.497 137.622 120.593 137.772C120.69 137.922 120.827 138.042 120.99 138.116C120.827 138.188 120.689 138.306 120.592 138.456C120.496 138.605 120.444 138.779 120.445 138.957C120.607 139.032 120.744 139.152 120.84 139.302C120.936 139.452 120.987 139.627 120.987 139.805C120.987 139.983 120.936 140.157 120.84 140.307C120.744 140.458 120.607 140.577 120.445 140.652C120.446 140.831 120.497 141.005 120.593 141.155C120.69 141.306 120.827 141.425 120.99 141.499C120.827 141.572 120.689 141.69 120.592 141.839C120.496 141.988 120.444 142.163 120.445 142.341C120.445 142.463 120.468 142.584 120.514 142.697C120.56 142.811 120.629 142.914 120.715 143.001C120.801 143.087 120.904 143.156 121.017 143.203C121.13 143.25 121.251 143.274 121.373 143.274H129.327C129.449 143.274 129.57 143.25 129.683 143.203C129.796 143.156 129.899 143.087 129.985 143.001C130.071 142.914 130.14 142.811 130.186 142.697C130.232 142.584 130.255 142.463 130.255 142.341C130.256 142.163 130.204 141.988 130.108 141.839C130.011 141.69 129.873 141.572 129.71 141.499C129.548 141.068 129.513 140.599 129.61 140.149C129.706 139.698 129.93 139.284 130.255 138.957C130.256 138.779 130.204 138.605 130.108 138.456C130.011 138.306 129.873 138.188 129.71 138.116C129.873 138.042 130.01 137.922 130.107 137.772C130.203 137.622 130.254 137.447 130.255 137.269Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M137.531 143.109H93.7109V152.078H137.531V143.109Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M137.531 147.332H93.7109V152.07H137.531V147.332Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M101.831 151.904H96.5859V156.809H101.831V151.904Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M117.729 151.904H112.484V156.809H117.729V151.904Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M133.635 151.904H128.391V156.809H133.635V151.904Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M138.377 125.846H99.4609V127.874H138.377V125.846Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M136.174 127.707H102.844V130.75H136.174V127.707Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M101.367 75.7873L97.7109 79.7773L120.662 100.808L124.318 96.8177L101.367 75.7873Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M124.13 107.984H119.844V119.037H124.13V107.984Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M123.663 119.191H120.336V121.041H123.663V119.191Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M128.08 104.612L124.156 106.338L128.606 116.455L132.529 114.73L128.08 104.612Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M132.155 115.059L129.109 116.398L129.854 118.091L132.9 116.752L132.155 115.059Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M120.953 93.252L116.438 97.767V110.625L130.879 107.013V98.4411L120.953 93.252Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M130.879 103.66L116.438 107.39V110.624L130.879 107.012V103.66Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0733 139.947C92.0733 139.947 98.8396 135.432 100.194 133.855C101.549 132.278 106.509 125.963 107.863 125.734C109.218 125.506 113.956 125.512 114.859 125.512C115.762 125.512 118.693 128.215 119.367 128.666C120.042 129.118 120.27 131.14 119.596 131.375C118.922 131.61 115.31 129.798 115.31 129.798L109.218 130.924C109.218 130.924 118.464 133.181 119.114 133.633C119.763 134.084 119.565 136.335 119.565 136.335L116.887 137.69C116.887 137.69 119.596 137.467 119.596 139.044C119.596 140.622 119.596 142.205 118.464 142.205H117.339C117.339 142.205 119.813 144.679 119.145 145.359C118.346 146.094 117.298 146.499 116.213 146.491C115.081 146.491 112.378 147.839 109.218 148.965C106.057 150.091 101.326 152.119 98.8396 152.571C96.3532 153.022 92.7536 153.474 92.7536 153.474C92.7536 153.474 92.5248 147.611 92.0733 145.805C91.6218 143.999 90.7188 140.615 90.7188 140.615L92.0733 139.947Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M116.889 137.689L112.102 138.555",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M117.335 142.205L112.609 143.17",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7996 93.4805C33.8679 97.9893 30.4847 108.368 30.4847 113.557C30.4847 118.746 26.1986 138.593 25.7471 145.811C25.2956 153.029 25.5244 157.563 30.0332 158.447C34.5421 159.332 48.7551 160.476 55.0761 159.795C61.3971 159.115 68.6397 159.121 78.5356 159.121C88.4315 159.121 93.2001 158.447 93.2001 158.447C93.8348 155.241 94.285 152.001 94.5484 148.743C94.7773 144.686 93.2001 138.593 92.5198 138.593C91.8394 138.593 81.0158 140.399 71.7693 141.525C62.5228 142.651 58.0078 141.074 56.4306 140.399C55.7237 140.042 54.9596 139.812 54.1731 139.719V136.787L51.4641 136.565L53.9381 120.775C53.9381 120.775 55.9729 119.42 56.6471 117.843C57.3212 116.266 58.2242 108.139 57.7727 103.178C57.3212 98.2181 52.5836 95.2803 52.5836 95.2803",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7996 93.4805C33.8679 97.9893 30.4847 108.368 30.4847 113.557C30.4847 118.746 26.1986 138.593 25.7471 145.811C25.2956 153.029 25.5244 157.563 30.0332 158.447C34.5421 159.332 48.7551 160.476 55.0761 159.795C61.3971 159.115 68.6397 159.121 78.5356 159.121C88.4315 159.121 93.2001 158.447 93.2001 158.447C93.8348 155.241 94.285 152.001 94.5484 148.743C94.7773 144.686 93.2001 138.593 92.5198 138.593C91.8394 138.593 81.0158 140.399 71.7693 141.525C62.5228 142.651 58.0078 141.074 56.4306 140.399C55.7237 140.042 54.9596 139.812 54.1731 139.719V136.787L51.4641 136.565L53.9381 120.775C53.9381 120.775 55.9729 119.42 56.6471 117.843C57.3212 116.266 58.2242 108.139 57.7727 103.178C57.3212 98.2181 52.5836 95.2803 52.5836 95.2803",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0177 138.371C51.0177 138.371 49.2116 141.525 42.4453 144.234",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6961 140.852C51.6961 140.852 41.5404 148.521 39.2891 151.453",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9141 143.782C30.9141 143.782 39.4864 143.553 45.5786 139.719",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8194 119.871C52.8194 119.871 50.7907 116.711 45.6016 113.779",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImage);
export default __webpack_public_path__ + "static/media/error_image.6bf8bf7b2f4b6eaff1db96f92dcc60fa.svg";
export { ForwardRef as ReactComponent };